import ImageDetails from "./ImageDetails";
import React, { useRef, useState } from "react";
import ImageEditorPlugin from "tui-image-editor";
import ImageViewer from "../KYCImageModal/ImageViewer";
import ImageOverlayToolbar from "./ImageOverlayToolbar";
import DocumentImageEditor from "./DocumentImageEditor";
import { CommonService } from "../../../services/Common";
import { notify } from "../../../shared/context/AlertContext";
import { useDocument } from "./DocumentComponentContext";

const EditDocumentModal = () => {
  const [instance, setInstance] = useState<ImageEditorPlugin | null>(null);
  const { document, updateDocument } = useDocument();
  const loanDetails = document.loanDetails;

  let photoDetails = [
    { label: "Name", value: loanDetails?.name || "-" },
    { label: "DOB", value: loanDetails?.dob || "-" },
    { label: "Phone Number", value: loanDetails?.mobile || "-" },
    { label: "PAN", value: loanDetails?.pan || "-" },
  ];

  return (
    <>
      <div className="md:h-[calc(90vh_-_92px)] grid grid-cols-4 grid-rows-1 gap-0">
        <section className="relative row-span-1 col-span-3">
          <ImageOverlayToolbar />
          {!document.showEditDocument && (
            <ImageViewer
              altText={document.documentName}
              src={
                document?.uploadedFile ||
                document.documentUrl.frontImagePath ||
                ""
              }
            />
          )}

          {document.showEditDocument && (
            <DocumentImageEditor
              src={document.documentUrl?.frontImagePath || ""}
              setInstance={(e: any) => {
                setInstance(e);
                updateDocument({ instance: e });
              }}
              isNew={false}
            />
          )}
        </section>

        <aside className="p-2 h-full border-l border-gray-200 col-span-1 row-span-1">
          <ImageDetails
            details={{
              title: "Photo",
              items: photoDetails,
            }}
          />
        </aside>
      </div>
    </>
  );
};

export default EditDocumentModal;
